import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { ROUTE } from './route-definition.model';
import PrivateComponent from '../components/private/private.component';
import NotFound from '../components/public/not-found/not-found.component';
import PrivateRoute from './private-route.component';
import ScrollToTop from '../commons/utils/scroll-to-top';
import LoginComponent from '../components/public/login/login.component';
import BusinessObjectStatisticPageComponent from '../components/private/pages/business-object-statistic/business-object-statistic-page.component';
import ImportCustomerCsvComponent from '../components/private/pages/import-customer-csv/import-customer-csv.component';
import CreditPackageOrderComponent from '../components/private/pages/credit-package-order/credit-package-order.component';
import SystemSmsBudgetComponent from '../components/private/pages/system-sms-budget/system-sms-budget.component';
import CreditPackageManagementComponent from '../components/private/pages/credit-package-management/credit-package-management.component';
import ServiceTagSettingsComponent from '../components/private/pages/service-tag-settings/service-tag-settings.component';
import ShortenedLinkComponent from '../components/private/pages/shortened-link/shortened-link.component';
import UserWatchlistComponent from '../components/private/pages/user-watchlist/user-watchlist.component';
import LexofficePageComponent from '../components/private/pages/lexoffice-page/lexoffice-page.component';
import InvoiceJobPageComponent from '../components/private/pages/invoice-job/invoice-job-page.component';
import UserCreateComponent from '../components/private/pages/user-context/pages/user-create/user-create.component';
import BusinessObjectCreateComponent from '../components/private/pages/business-object-context/pages/business-object-create/business-object-create.component';
import CategoryCreateComponent from '../components/private/pages/category-context/pages/category-create/category-create.component';
import MassiveCreateCategoryAndProductComponent from '../components/private/pages/category-context/pages/massive-create-category-and-product/massive-create-category-and-product.component';
import BusinessObjectListComponent from '../components/private/pages/business-object-context/pages/business-object-list/business-object-list.component';
import UserListComponent from '../components/private/pages/user-context/pages/user-list/user-list.component';
import ProductListComponent from '../components/private/pages/product-context/page/product-list/product-list.component';
import ProductCreateComponent from '../components/private/pages/product-context/page/product-create/product-create.component';
import CategoryListComponent from '../components/private/pages/category-context/pages/category-list/category-list.component';
import UserDetailComponent from '../components/private/pages/user-context/pages/user-detail/user-detail.component';
import BusinessObjectDetailComponent from '../components/private/pages/business-object-context/pages/business-object-detail/business-object-detail.component';
import CategoryDetailComponent from '../components/private/pages/category-context/pages/category-detail/category-detail.component';
import ProductDetailComponent from '../components/private/pages/product-context/page/product-detail/product-detail.component';
import UserDetailContextComponent from '../components/private/pages/user-context/pages/user-detail/user-detail-context.component';
import BusinessObjectContext from '../components/private/pages/business-object-context/business-object-context';
import BusinessObjectDetailContext from '../components/private/pages/business-object-context/pages/business-object-detail/business-object-detail-context';
import CategoryContextComponent from '../components/private/pages/category-context/category-context.component';
import CategoryDetailContextComponent from '../components/private/pages/category-context/pages/category-detail/category-detail-context.component';
import ProductContextComponent from '../components/private/pages/product-context/product-context.component';
import FlyerCampaignPage from '../components/private/pages/flyer-campaign/flyer-campaign-page.component';

export default function RouteMapping() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div>
        <Routes>
          <Route index element={<LoginComponent />} />

          <Route element={<PrivateRoute />}>
            <Route path={ROUTE.PRIVATE} element={<PrivateComponent />}>
              <Route index element={<UserWatchlistComponent />}></Route>
              <Route path={ROUTE.STATISTIC} element={<BusinessObjectStatisticPageComponent />}></Route>
              <Route path={ROUTE.USER}>
                <Route index element={<UserListComponent />}></Route>
                <Route path={ROUTE.USER_CREATE} element={<UserCreateComponent />}></Route>
                <Route path={ROUTE.USER_DETAIL} element={<UserDetailContextComponent />}>
                  <Route index element={<UserDetailComponent />}></Route>
                  <Route path={ROUTE.BUSINESS_OBJECT} element={<BusinessObjectContext />}>
                    <Route index element={<BusinessObjectListComponent />}></Route>
                    <Route path={ROUTE.BUSINESS_OBJECT_CREATE} element={<BusinessObjectCreateComponent />}></Route>
                    <Route path={ROUTE.BUSINESS_OBJECT_DETAIL} element={<BusinessObjectDetailContext />}>
                      <Route index element={<BusinessObjectDetailComponent />}></Route>
                      <Route path={ROUTE.CATEGORY} element={<CategoryContextComponent />}>
                        <Route index element={<CategoryListComponent />}></Route>
                        <Route path={ROUTE.CATEGORY_CREATE} element={<CategoryCreateComponent />}></Route>
                        <Route
                          path={ROUTE.MASSIVE_CREATE}
                          element={<MassiveCreateCategoryAndProductComponent />}
                        ></Route>
                        <Route path={ROUTE.CATEGORY_DETAIL} element={<CategoryDetailContextComponent />}>
                          <Route index element={<CategoryDetailComponent />}></Route>
                          <Route path={ROUTE.PRODUCT} element={<ProductContextComponent />}>
                            <Route index element={<ProductListComponent />}></Route>
                            <Route path={ROUTE.PRODUCT_CREATE} element={<ProductCreateComponent />}></Route>
                            <Route path={ROUTE.PRODUCT_DETAIL} element={<ProductDetailComponent />}></Route>
                          </Route>
                        </Route>
                      </Route>
                    </Route>
                  </Route>
                </Route>
              </Route>
              <Route path={ROUTE.IMPORT_CUSTOMER_CSV} element={<ImportCustomerCsvComponent />}></Route>
              <Route path={ROUTE.CREDIT_PACKAGE_ORDER} element={<CreditPackageOrderComponent />}></Route>
              <Route path={ROUTE.SYSTEM_WALLET} element={<SystemSmsBudgetComponent />}></Route>
              <Route path={ROUTE.CREDIT_PACKAGE_MANAGEMENT} element={<CreditPackageManagementComponent />}></Route>
              <Route path={ROUTE.SERVICE_TAG_MANAGEMENT} element={<ServiceTagSettingsComponent />}></Route>
              <Route path={ROUTE.SHORTENED_LINK} element={<ShortenedLinkComponent />}></Route>
              <Route path={ROUTE.USER_WATCHLIST} element={<UserWatchlistComponent />}></Route>
              <Route path={ROUTE.LEXOFFICE} element={<LexofficePageComponent />}></Route>
              <Route path={ROUTE.INVOICE_JOB} element={<InvoiceJobPageComponent />}></Route>
              <Route path={ROUTE.FLYER_CAMPAIGN} element={<FlyerCampaignPage />}></Route>
            </Route>
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}
